export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "sepa_mandate_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mandat de prélèvement SEPA"])},
        "sepa_mandate_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Le mandat autorisant le prélèvement de vos échéances sur votre compte bancaire"])}
      },
      "en": {
        "sepa_mandate_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SEPA direct debit mandate"])},
        "sepa_mandate_description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["The mandate authorising the direct debit of your instalments from your bank account"])}
      }
    }
  })
}
